import {ChangeDetectionStrategy, Component, computed, contentChildren, input} from '@angular/core';
import {
  ColumnType,
  HarbourDuesRotterdamProFormaColumnDirective
} from './harbour-dues-rotterdam-pro-forma-column.directive';
import {HarbourDuesRotterdamProFormaValueDirective} from './harbour-dues-rotterdam-pro-forma-value.directive';

@Component({
  selector: 'app-harbour-dues-rotterdam-pro-forma-table',
  templateUrl: './harbour-dues-rotterdam-pro-forma-table.component.html',
  styleUrl: './harbour-dues-rotterdam-pro-forma-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HarbourDuesRotterdamProFormaTableComponent {
  private readonly TOTAL_WIDTH = 12;
  private readonly OPERATION_NARROW_COLUMN_WIDTH = 1;
  private readonly LAST_COLUMN_WIDTH = 3;
  private readonly DEFAULT_COLUMN_WIDTH = 2;

  protected readonly ColumnType = ColumnType;

  protected readonly header = input.required<string>();
  protected readonly data = input.required<any[]>();
  protected readonly columns = contentChildren(
    HarbourDuesRotterdamProFormaColumnDirective
  );
  protected readonly values = contentChildren(
    HarbourDuesRotterdamProFormaValueDirective,
    { descendants: true}
  );

  protected readonly columnWidths = computed(() => {
    const lastIndex = this.columns().length - 1;
    const operationsCount = this.columns().filter(
      column => column.type() === ColumnType.OPERATION
    ).length;
    const columnWidths = this.columns().map((column, index): number => {
      switch (index) {
        case 0:
          return 0;
        case lastIndex:
          return this.LAST_COLUMN_WIDTH;
        default:
          if (column.type() === ColumnType.OPERATION && operationsCount > 1 && index === 1) {
            return this.OPERATION_NARROW_COLUMN_WIDTH;
          } else {
            return this.DEFAULT_COLUMN_WIDTH;
          }
      }
    });
    const columnWidthsTotal = columnWidths.reduce((a : number, b: number) => a + b, 0);
    columnWidths[0] = this.TOTAL_WIDTH - columnWidthsTotal;
    return columnWidths;
  });

  protected readonly discountLabels = computed(
    () => this.values().filter(value => value.isDiscountLabel())
  );

  protected readonly discountValues = computed(
    () => this.values().filter(value => value.isDiscountValue())
  );

  protected readonly subTotal = computed(
    () => this.values().find(value => value.isSubTotal())
  );
}
